import cn from "classnames"

import { Card, Empty, Flex } from "@/atoms"
import { Heading } from "@/molecules/Heading"
import { LoaderWidget } from "./components/LoaderWidget"

import styles from "./Widget.module.scss"

import type { WidgetComponent } from "."

export const Widget: WidgetComponent = (props) => {
  const { children, title, className, popover, loading, aside, capitalize } =
    props

  return (
    <Card
      className={cn(styles.container, loading && styles.loading, className)}
    >
      {title && (
        <Flex
          justify="space-between"
          align="center"
          className={cn(aside && styles.titleContainer)}
        >
          <Heading
            capitalize={capitalize}
            level={6}
            title={title}
            popover={popover}
            classes={{
              container: cn(!aside && styles.titleContainer),
              title: styles.title
            }}
          />
          {aside}
        </Flex>
      )}
      {!loading && children && <div className={styles.body}>{children}</div>}
      {!loading && !children && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
      {loading && <LoaderWidget />}
    </Card>
  )
}
